import { FC } from "react";

import { PlannerInsert } from "../planner/PlannerInsert";

import { SectionPageList } from "./SectionPageList";
import { TopicList } from "./TopicList";

import { useCapabilities } from "store/capability-hooks";

export const SectionContentView: FC = () => {
  const { canAuthorSection } = useCapabilities();

  return (
    <div className="flex max-w-full flex-col-reverse gap-6 bg-white pb-4 md:flex-row md:items-start">
      <main className="my-4 min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap">
        {/* Topics */}
        <TopicList />

        {/* Assignments */}
        <SectionPageList canEdit={canAuthorSection} category="assignment" shouldTruncateList />

        {/* Course Resources */}
        <SectionPageList canEdit={canAuthorSection} category="course_resource" shouldTruncateList />

        {/* Instructor Workspace */}
        {canAuthorSection && (
          <SectionPageList
            canEdit={canAuthorSection}
            category="instructor_workspace"
            shouldTruncateList
          />
        )}
      </main>

      <PlannerInsert />
    </div>
  );
};
